import { Component, effect, inject, input, OnInit } from '@angular/core';
import { SchedulerStepService } from '@app/services/step/scheduler-step.service';
import { BranchService } from '@app/services/branch/branch.service';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NavigationComponent } from '../global/navigation/navigation.component';
import { BreadcrumbsComponent } from '../breadcrumbs/breadcrumbs.component';
import { TitleComponent } from '../title/title.component';
import { BranchComponent } from '../branch/branch.component';
import { filter } from 'rxjs';
import { KioskSideComponent } from '../kiosk-side/kiosk-side.component';
import { Settings } from '@app/services/fetch/settings';
import { TextService } from '@app/services/text/text.service';
import { LoadingComponent } from '../global/loading/loading.component';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'afcu-card',
  standalone: true,
  imports: [
    NavigationComponent,
    BreadcrumbsComponent,
    BranchComponent,
    TitleComponent,
    KioskSideComponent,
    RouterOutlet,
    LoadingComponent
  ],
  templateUrl: './card.component.html',
  styleUrl: './card.component.css'
})
export class CardComponent implements OnInit{
  protected schedulerService = inject( SchedulerStepService );
  protected branchService = inject( BranchService );
  protected fetchSettings = inject( Settings );
  protected textService = inject( TextService)

  protected path = ''

  branchView = input.required<boolean>()

  categoryGroups:Record<string, ServiceType> = {}
  errorAPI: boolean = true
  origin: string = ''
  isToken = false

  constructor(private router: Router, private route: ActivatedRoute){
    this.path = this.router.url
    effect (() => {
      this.schedulerService.settings.set(this.fetchSettings.settings())
    })
    this.route.queryParams.subscribe(params => {
      this.origin = params['origin']
      this.isToken = (params['token']) ?? false
      if(this.isToken){
        const now = new Date().getTime()
        if(now-Number(this.isToken) >=0){
          this.router.navigate(['/information/session'])
        }
      }
    })
  }
  get isLoading() {
    return (this.schedulerService.settings() !== undefined) ? Object.keys(this.schedulerService.settings()).length > 0 : true
  }

  get Settings() {
    return this.fetchSettings.settings()
  }

get CssClass() {
    let cssClass = 'col-span-12';
 
    if (this.origin === undefined)
      cssClass = 'col-span-9'
 
    if(this.Settings.GLOBAL.kiosk_allow_device.enabled || this.Settings.GLOBAL.kiosk_tower_ad.enabled)
        cssClass = 'col-span-9 pr-11'
 
    if(this.path.includes('your-appointment'))
      if(this.origin !== undefined)
        cssClass = 'col-span-9'
      else
        cssClass = 'col-span-12'
 
    return cssClass
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.path = event.urlAfterRedirects;
      });
  }
}
